import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Header from "./header.js";
import Main from "./main.js";
import Footer from "./footer.js";

let currentVersion = "1.1.16-current";
let currentStableVersion = "1.0.0";
let currentViewerVersion = "0.7.0";

function Index(props) {
  return (
    <div>
      <CssBaseline />
      <Header
        currentVersion={currentVersion}
        currentViewerVersion={currentViewerVersion}
      />
      <Main
        currentVersion={currentVersion}
        currentStableVersion={currentStableVersion}
        currentViewerVersion={currentViewerVersion}
      />
      <Footer />
    </div>
  );
}

export default Index;
